import { render, staticRenderFns } from "./MdRankList.vue?vue&type=template&id=8cd56d92&scoped=true&"
import script from "./MdRankList.vue?vue&type=script&lang=js&"
export * from "./MdRankList.vue?vue&type=script&lang=js&"
import style0 from "./MdRankList.vue?vue&type=style&index=0&id=8cd56d92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd56d92",
  null
  
)

export default component.exports